/*
 * 类目资质配置 - 枚举（使用 @xhgj/xh-jsutils createEnum 插件）
 * 适用场景（父/子）、必传资料附件类型（12 类）
 */
import { createEnum } from '@xhgj/xh-jsutils'
// 必传资料附件类型（12 选 N，至少 1）—— value 由需求给定
export const AttachTypeList = [
  { label: '安全生产许可证', value: 'SAFETY_PRODUCTION_LICENSE' },
  { label: '生产许可证', value: 'PRODUCTION_LICENSE' },
  { label: '3C认证（消防3C证书）', value: 'CCC_CERT' },
  { label: '特种劳动防护用品安全标志(LA)', value: 'LA_CERT' },
  { label: 'MA认证（矿用产品安全标志）', value: 'MA_CERT' },
  { label: '船级社证书', value: 'CCS_CERT' },
  { label: '品牌授权', value: 'BRAND_AUTHORIZATION' },
  {
    label: '检测报告',
    value: 'TEST_REPORT',
  },
  {
    label:
      '合格证（包含商品名称、规格型号、品牌和生产厂家，生产厂址，检验合格相关盖章证明）',
    value: 'CERTIFICATE_OF_CONFORMITY',
  },
  { label: '原材料质量证明书', value: 'RAW_MATERIAL_QUALITY_CERTIFICATE' },
  { label: '钢厂原厂材质单', value: 'STEEL_MILL_MATERIAL_CERT' },
  { label: '自愿性认证', value: 'VOLUNTARY_CERT' },
  { label: '商标注册证', value: 'TRADEMARK_REGISTRATION_CERTIFICATE' },
] as const
export const AttachTypeEnum = createEnum(AttachTypeList)

// 审核来源（用于按物料拉取必传资质配置等场景）
export const NewSourceSceneList = [
  { label: 'MPM新增物料', value: 'MPM_ADD' },
  { label: 'MPM批量新增', value: 'MPM_BATCH_ADD' },
  { label: 'SCP新增物料', value: 'SRM_SECOND_ADD' },
  { label: 'PLM新增物料', value: 'PLM_ADD' },
  { label: 'IQS单个新增', value: 'IQS_ADD' },
  { label: 'OMS新增物料', value: 'OMS_DIRECTIONAL_ADD' },
  { label: 'MPM修改物料', value: 'MPM_UPDATE' },
  { label: 'MPM导入批改', value: 'MPM_IMPORT_UPDATE' },
  { label: 'SCP修改审核', value: 'SRM_UPDATE' },
  { label: 'PLM修改物料', value: 'PLM_UPDATE' },
  { label: 'OMS修改物料', value: 'OMS_UPDATE' },
] as const
export const NewSourceSceneEnum = createEnum(NewSourceSceneList)
/*
 * 类目资质配置 - 枚举（使用 @xhgj/xh-jsutils createEnum 插件）
 * 适用场景（父/子）、必传资料附件类型（12 类）
 */
import { createEnum } from '@xhgj/xh-jsutils'
// 必传资料附件类型（12 选 N，至少 1）—— value 由需求给定
export const AttachTypeList = [
  { label: '安全生产许可证', value: 'SAFETY_PRODUCTION_LICENSE' },
  { label: '生产许可证', value: 'PRODUCTION_LICENSE' },
  { label: '3C认证（消防3C证书）', value: 'CCC_CERT' },
  { label: '特种劳动防护用品安全标志(LA)', value: 'LA_CERT' },
  { label: 'MA认证（矿用产品安全标志）', value: 'MA_CERT' },
  { label: '船级社证书', value: 'CCS_CERT' },
  { label: '品牌授权', value: 'BRAND_AUTHORIZATION' },
  {
    label: '检测报告',
    value: 'TEST_REPORT',
  },
  {
    label:
      '合格证（包含商品名称、规格型号、品牌和生产厂家，生产厂址，检验合格相关盖章证明）',
    value: 'CERTIFICATE_OF_CONFORMITY',
  },
  { label: '原材料质量证明书', value: 'RAW_MATERIAL_QUALITY_CERTIFICATE' },
  { label: '钢厂原厂材质单', value: 'STEEL_MILL_MATERIAL_CERT' },
  { label: '自愿性认证', value: 'VOLUNTARY_CERT' },
  { label: '商标注册证', value: 'TRADEMARK_REGISTRATION_CERTIFICATE' },
] as const
export const AttachTypeEnum = createEnum(AttachTypeList)

// 审核来源（用于按物料拉取必传资质配置等场景）
export const NewSourceSceneList = [
  { label: 'MPM新增物料', value: 'MPM_ADD' },
  { label: 'MPM批量新增', value: 'MPM_BATCH_ADD' },
  { label: 'SCP新增物料', value: 'SRM_SECOND_ADD' },
  { label: 'PLM新增物料', value: 'PLM_ADD' },
  { label: 'IQS单个新增', value: 'IQS_ADD' },
  { label: 'OMS新增物料', value: 'OMS_DIRECTIONAL_ADD' },
  { label: 'MPM修改物料', value: 'MPM_UPDATE' },
  { label: 'MPM导入批改', value: 'MPM_IMPORT_UPDATE' },
  { label: 'SCP修改审核', value: 'SRM_UPDATE' },
  { label: 'PLM修改物料', value: 'PLM_UPDATE' },
  { label: 'OMS修改物料', value: 'OMS_UPDATE' },
] as const
export const NewSourceSceneEnum = createEnum(NewSourceSceneList)
